import { Box, Button, Dialog, Theme, Typography } from '@mui/material';
import React from 'react'

type Props = {
    handleValidationDialogClose: () => void,
    isValidationDialogVisible: boolean
    validationErrorsArray: { schemeName: string; errorMessage: string }[]
}

export default function ValidateDialogBox({ handleValidationDialogClose, isValidationDialogVisible, validationErrorsArray }: Props) {
    return (
        <Dialog
            onClose={handleValidationDialogClose}
            open={isValidationDialogVisible}
            maxWidth='sm'
            sx={(theme: Theme) => ({
                '& .MuiPaper-root': {
                    borderRadius: '12px',
                    backgroundColor: theme.palette.common.white,
                    padding: "24px",
                    width: "533px",
                },
            })}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    rowGap: "30px"
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        rowGap: "14px",
                        paddingTop: "15px"
                    }}
                >
                    <Box
                        component="img"
                        src="/images/error.svg"
                        alt="Error"
                        sx={{ objectFit: "contain" }}
                    />
                    <Typography
                        variant="h2"
                        sx={(theme: Theme) => ({
                            lineHeight: "25px",
                            letterSpacing: "0.01px",
                            color: theme.palette.text.primary
                        })}
                    >
                        Failed!
                    </Typography>
                </Box>
                <Box
                    sx={{
                        maxHeight: "350px",
                        overflowY: "auto",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: validationErrorsArray?.length === 1 ? "center" : "flex-start",
                        alignItems: "center",
                        rowGap: "10px"
                    }}
                >
                    {validationErrorsArray?.map((obj: { schemeName: string; errorMessage: string }, index: number) => (
                        <Box
                            key={index}
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                rowGap: "10px"
                            }}
                        >
                            <Typography
                                variant="subtitle_400"
                                sx={(theme: Theme) => ({
                                    fontWeight: "600",
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.secondary
                                })}
                            >
                                {obj?.schemeName}
                            </Typography>
                            <Typography
                                variant="subtitle_400"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.secondary,
                                    paddingBottom: "10px"
                                })}
                            >
                                {obj?.errorMessage.charAt(0).toUpperCase() + obj?.errorMessage.slice(1)}
                            </Typography>
                            {validationErrorsArray?.length - 1 !== index && (
                                <Box
                                    sx={(theme: Theme) => ({
                                        width: "30%",
                                        border: `0.5px dashed ${theme.palette.text.secondary}`
                                    })}
                                />
                            )}
                        </Box>
                    ))}
                </Box>
                <Button
                    variant="contained"
                    fullWidth
                    sx={(theme: Theme) => ({
                        padding: "13px 20px",
                        borderRadius: "4px",
                        backgroundColor: theme.palette.primary[500],
                        fontWeight: 600,
                        fontSize: "16px",
                        lineHeight: "20px"
                    })}
                    onClick={handleValidationDialogClose}
                >
                    Okay
                </Button>
            </Box>
        </Dialog >
    )
}